import React, { useEffect, useState } from "react";
import PageView from "../../components/PageView";
import CommonPageTitle from "../../components/CommonPageTitle";
import { useTranslationHook } from "../../hooks/useTranslationHook";
import CommonNavBar from "../../components/CommonNavBar";
import { imagesUrls } from "../../../constants";
import useThemeHook from "../../hooks/useThemeHook";
import { THEME_COLORS } from "../../themes/DarkLight";
import CommonButton from "../../components/CommonButton";
import { SwapVertical } from "react-ionicons";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

interface Crypto {
  image: string;
  price_change_percentage_24h: number;
  current_price: number;
  name: string;
}

const SwapPage: React.FC = () => {
  const piPrice = useSelector((state: any) => state?.piPrice);
  const initialCryptos: Crypto[] = [
    {
      image: imagesUrls["arthereum"],
      price_change_percentage_24h: 0,
      current_price: 0.001,
      name: "Arthereum",
    },
    {
      image: imagesUrls["pi"],
      price_change_percentage_24h: 0,
      current_price: piPrice,
      name: "PiCoin",
    },
  ];

  const handleDirectionSwap = () => {
    // Swap the cryptos and amounts
    // setInputCrypto(outputCrypto);
    // setOutputCrypto(inputCrypto);
    // setInputAmount(outputAmount);
    // calculateOutputAmount(outputCrypto, inputCrypto, outputAmount);
  };

  const handleSwap = () => {
    alert(getTranslationText("swap_available_on_mainnet", { price: piPrice }));
  };
  const handleInputAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value) || 0;
    if (value >= 0) {
      setInputAmount(value);
      if (inputCrypto) {
        const balanceKey = inputCrypto.name.toLowerCase();
        const availableBalance = (balances as any)[balanceKey] || 0;

        if (value > availableBalance) {
          setWarningText(
            `Insufficient balance. Available: ${availableBalance.toFixed(6)} ${
              inputCrypto.name
            }`
          );
        } else {
          setWarningText(""); // Clear warning if input is valid
        }
      }

      calculateOutputAmount(inputCrypto, outputCrypto, value);
    }
  };

  const location = useLocation(); // Hook to access location state
  console.log(location);

  const getTranslationText = useTranslationHook();
  const userData = useSelector((state: any) => state?.actualUser);
  const user = userData?.user;
  const balances = {
    bitcoin: user?.bitcoinBalance || 0,
    arthereum: user?.arthereumBalance || 0,
    picoin: user?.picoinBalance || 0,
  };
  const [featuredCryptos, setFeaturedCryptos] =
    useState<Crypto[]>(initialCryptos);
  const [warningText, setWarningText] = useState<string>("");
  const [inputCrypto, setInputCrypto] = useState<Crypto | null>(null);
  const [outputCrypto, setOutputCrypto] = useState<Crypto | null>(null);
  const [inputAmount, setInputAmount] = useState<number>(0);
  const [outputAmount, setOutputAmount] = useState<number>(0);
  const theme = useThemeHook();

  useEffect(() => {
    const fetchCryptoPrices = async () => {
      try {
        const response = await axios.get(
          "https://api.coingecko.com/api/v3/coins/markets",
          {
            params: {
              vs_currency: "usd",
              ids: "bitcoin,ethereum,tether", // Add any other cryptos here
            },
          }
        );

        const updatedCryptos = response.data.map((crypto: any) => ({
          image: crypto.image,
          price_change_percentage_24h: crypto.price_change_percentage_24h,
          current_price: crypto.current_price,
          name: crypto.name,
        }));

        setFeaturedCryptos((prev) => [
          ...prev,
          ...updatedCryptos.filter(
            (crypto: Crypto) =>
              !prev.find((prevCrypto) => prevCrypto.name === crypto.name)
          ),
        ]);

        // Dynamically set inputCrypto based on navigation state or default to the first fetched crypto
        const stateCryptoName = location.state?.crypto?.name;
        const initialInputCrypto =
          updatedCryptos.find(
            (crypto: any) => crypto.name === stateCryptoName
          ) ||
          featuredCryptos.find(
            (crypto: any) => crypto.name === stateCryptoName
          ) ||
          updatedCryptos[0];

        setInputCrypto(initialInputCrypto);
        setOutputCrypto(
          updatedCryptos.find(
            (crypto: any) => crypto.name !== initialInputCrypto.name
          )
        );
      } catch (error) {
        console.error("Error fetching crypto prices:", error);
      }
    };

    // fetchCryptoPrices();
  }, [location.state]);

  const calculateOutputAmount = (
    inputCrypto: Crypto | null,
    outputCrypto: Crypto | null,
    inputAmount: number
  ) => {
    if (
      inputCrypto &&
      outputCrypto &&
      inputCrypto.current_price > 0 &&
      outputCrypto.current_price > 0 &&
      inputAmount > 0
    ) {
      const amountInUSDT = inputAmount * inputCrypto.current_price;
      const output = amountInUSDT / outputCrypto.current_price;
      setOutputAmount(parseFloat(output.toFixed(6)));
    } else {
      setOutputAmount(0);
    }
  };

  const handleInputCryptoChange = (cryptoName: string) => {
    const selectedCrypto = featuredCryptos.find(
      (crypto) => crypto.name === cryptoName
    );
    if (selectedCrypto) {
      setInputCrypto(selectedCrypto);
      setWarningText("");
      calculateOutputAmount(selectedCrypto, outputCrypto, inputAmount);
    }
  };

  const handleOutputCryptoChange = (cryptoName: string) => {
    const selectedCrypto = featuredCryptos.find(
      (crypto) => crypto.name === cryptoName
    );
    if (selectedCrypto) {
      setOutputCrypto(selectedCrypto);
      if (selectedCrypto.name === inputCrypto?.name) {
        const newInputCrypto = featuredCryptos.find(
          (crypto) => crypto.name !== selectedCrypto.name
        );
        if (newInputCrypto) {
          setInputCrypto(newInputCrypto);
          calculateOutputAmount(newInputCrypto, selectedCrypto, inputAmount);
        }
      } else {
        calculateOutputAmount(inputCrypto, selectedCrypto, inputAmount);
      }
    }
  };
  return (
    <PageView>
      <CommonNavBar />
      <CommonPageTitle padding={0} title={getTranslationText("swap")} />
      <div
        style={{
          width: "100%",
          padding: "10px",
          backgroundColor: THEME_COLORS[theme].component_background_color,
          borderRadius: "10px",
          boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flex: 1,
              }}
            >
              <img
                src={inputCrypto?.image}
                alt={inputCrypto?.name}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: THEME_COLORS[theme].less_theme,
                }}
              />
              <select
                value={inputCrypto?.name}
                onChange={(e) => handleInputCryptoChange(e.target.value)}
                style={{
                  flex: 1,
                  backgroundColor:
                    THEME_COLORS[theme].component_background_color,
                  padding: "10px",
                  fontSize: "16px",
                  color: THEME_COLORS[theme].inverse_theme,
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              >
                {featuredCryptos
                  .filter((crypto) => crypto.name !== outputCrypto?.name)
                  .map((crypto) => (
                    <option key={crypto.name} value={crypto.name}>
                      {crypto.name}
                    </option>
                  ))}
              </select>
            </div>
            <input
              type="number"
              value={inputAmount}
              onChange={handleInputAmountChange}
              style={{
                width: "100%",

                backgroundColor: THEME_COLORS[theme].less_theme,
                padding: "10px",
                color: THEME_COLORS[theme].inverse_theme,
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>
          {/* Swap Icon Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={handleDirectionSwap}
          >
            <SwapVertical
              width={"30px"}
              height={"30px"}
              color={THEME_COLORS[theme].inverse_theme}
              title="Swap Direction"
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                flex: 1,
              }}
            >
              <img
                src={outputCrypto?.image}
                alt={outputCrypto?.name}
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                }}
              />
              <select
                value={outputCrypto?.name}
                onChange={(e) => handleOutputCryptoChange(e.target.value)}
                style={{
                  flex: 1,
                  padding: "10px",
                  fontSize: "16px",
                  backgroundColor:
                    THEME_COLORS[theme].component_background_color,
                  color: THEME_COLORS[theme].inverse_theme,
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                }}
              >
                {featuredCryptos
                  .filter((crypto) => crypto.name !== inputCrypto?.name)
                  .map((crypto) => (
                    <option key={crypto.name} value={crypto.name}>
                      {crypto.name}
                    </option>
                  ))}
              </select>
            </div>
            <input
              type="number"
              value={outputAmount}
              readOnly
              style={{
                width: "100%",
                backgroundColor: THEME_COLORS[theme].less_theme,
                color: THEME_COLORS[theme].inverse_theme,
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          </div>
          <CommonButton
            onClickHandle={handleSwap}
            text={getTranslationText("swap")}
          />
        </div>
      </div>
      {warningText && (
        <p style={{ color: "red", margin: "0 10px" }}>{warningText}</p>
      )}
    </PageView>
  );
};

export default SwapPage;
